module.exports = __webpack_public_path__ + "media/svg/camera-5056ca8f.svg";